import { Button, Spinner } from 'react-bootstrap'
import { useQsFilters } from '../../hooks/filters'
import dayjs from 'dayjs'
// locaalize dayjs
import 'dayjs/locale/it'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import { useMemo, useRef, useState } from 'react'
import { ViewContentArg } from '@fullcalendar/core/index.js'
import ModalPianificazioneTaratura from '../Interventi/ModalPianificazioneTaratura'
import ModalPianificazionePeriodica from '../Interventi/ModalPianificazionePeriodica'
import { fetchApi } from '@inmagik/react-crud'
import { API_URL, INTERVENTI_OPTIONS_TAB } from '../../constants'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { useAuth } from '../../auth'
import { useBilanceScadenze } from '../../hooks/bilance'
import ModalRichiesteDaCalendario from '../ClienteDettaglio/ModalRichiesteDaCalendario'
import MaterialIcon from '../../components/MaterialIcon'
import { useIsCliente } from '../../utils/utils'
import { SegmentedControlLink } from '../../components/SegmentedControlLink'

dayjs.locale('it')

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? 'data',
  data_lte: params.get('data_lte') ?? dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
  data_gte: params.get('data_gte') ?? dayjs().add(1, 'month').format('YYYY-MM-DD'),
  rapporto_taratura: params.get('rapporto_taratura') ?? 'true',
  verifica_periodica: params.get('verifica_periodica') ?? 'true',
})

export default function CalendarioScadenze() {
  const isCliente = useIsCliente()
  const { filters, setFilters } = useQsFilters(initFilters)
  const {
    data: bilance,
    refetch,
    isFetching,
  } = useBilanceScadenze({
    search: filters.search,
    ordering: filters.ordering,
    data_gte: filters.data_gte,
    data_lte: filters.data_lte,
    rapporto_taratura: filters.rapporto_taratura,
    verifica_periodica: filters.verifica_periodica,
  })

  const [modalStatePianificaPeriodica, modalActionsPianificaPeriodica] = useModalTrigger()
  const [modalStatePianificaTaratura, modalActionsPianificaTaratura] = useModalTrigger()

  const [modalStateAddRichiesta, modalActionsAddRichiesta] = useModalTrigger()

  const { tokens } = useAuth()

  const events = useMemo(() => {
    if (!bilance) {
      return []
    }
    let eventsToReturn: any[] = []
    bilance.map((bilancia) => {
      if (
        dayjs(bilancia.data_scadenza_periodica).isBefore(dayjs(filters.data_gte).add(1, 'day')) &&
        dayjs(bilancia.data_scadenza_periodica).isAfter(dayjs(filters.data_lte).diff(1, 'day')) &&
        dayjs(bilancia.data_scadenza_taratura).isBefore(dayjs(filters.data_gte).add(1, 'day')) &&
        dayjs(bilancia.data_scadenza_taratura).isAfter(dayjs(filters.data_lte).diff(1, 'day'))
      ) {
        eventsToReturn.push({
          title: bilancia.cliente_ragione_sociale,
          pk: bilancia.id,
          start: bilancia.data_scadenza_periodica,
          tipo_intervento: 'verifica_periodica',
          end: dayjs(bilancia.data_scadenza_periodica).add(4, 'hour').format(),
          pk_cliente: bilancia.cliente_pk,
          bilance_count: 1,
          bilance_pk: [bilancia.id],
        })
        eventsToReturn.push({
          title: bilancia.cliente_ragione_sociale,
          pk: bilancia.id,
          start: bilancia.data_scadenza_taratura,
          tipo_intervento: 'rapporto_taratura',
          end: dayjs(bilancia.data_scadenza_taratura).add(4, 'hour').format(),
          pk_cliente: bilancia.cliente_pk,
          bilance_count: 1,
          bilance_pk: [bilancia.id],
        })
      } else {
        eventsToReturn.push({
          title: bilancia.cliente_ragione_sociale,
          pk: bilancia.id,
          start:
            bilancia.data_scadenza_periodica &&
            // check if the bilancia as a data_scadenza_periodica inside the filter range show it as verifica_periodica else show it as rapporto_taratura
            dayjs(bilancia.data_scadenza_periodica).isBefore(dayjs(filters.data_gte).add(1, 'day')) &&
            dayjs(bilancia.data_scadenza_periodica).isAfter(dayjs(filters.data_lte).diff(1, 'day'))
              ? bilancia.data_scadenza_periodica
              : bilancia.data_scadenza_taratura,
          tipo_intervento:
            // if the bilancia as a data_scadenza_periodica inside the filter range show it as verifica_periodica else show it as rapporto_taratura
            dayjs(bilancia.data_scadenza_periodica).isBefore(dayjs(filters.data_gte).add(1, 'day')) &&
            dayjs(bilancia.data_scadenza_periodica).isAfter(dayjs(filters.data_lte).diff(1, 'day'))
              ? 'verifica_periodica'
              : 'rapporto_taratura',
          end: dayjs(
            // check if the bilancia as a data_scadenza_periodica inside the filter range show it as verifica_periodica else show it as rapporto_taratura
            dayjs(bilancia.data_scadenza_periodica).isBefore(dayjs(filters.data_gte).add(1, 'day')) &&
              dayjs(bilancia.data_scadenza_periodica).isAfter(dayjs(filters.data_lte).diff(1, 'day'))
              ? bilancia.data_scadenza_periodica
              : bilancia.data_scadenza_taratura
          )
            .add(4, 'hour')
            .format(),
          pk_cliente: bilancia.cliente_pk,
          bilance_count: 1,
          bilance_pk: [bilancia.id],
          // }
        })
      }
      return eventsToReturn
    })

    const groupedEvents = eventsToReturn.reduce((acc: any, event: any) => {
      const existingEvent = acc.find(
        (e: any) =>
          dayjs(e.start).isSame(dayjs(event.start), 'day') &&
          e.title === event.title &&
          e.tipo_intervento === event.tipo_intervento
      )
      if (existingEvent) {
        return acc.map((e: any) => {
          if (
            dayjs(e.start).isSame(dayjs(event.start), 'day') &&
            e.title === event.title &&
            e.tipo_intervento === event.tipo_intervento
          ) {
            return {
              ...e,
              end: event.end,
              bilance_count: e.bilance_count + event.bilance_count,
              bilance_pk: [...e.bilance_pk, event.pk],
            }
          }
          return e
        })
      }
      return [...acc, event] as any
    }, [])

    return groupedEvents
  }, [bilance])

  // console.log(events)

  const ref = useRef<HTMLDivElement>(null)

  const [isDownloadInterventiXlsx, setIsDownloadInterventiXlsx] = useState(false)

  const [isDownloadInterventiPdf, setIsDownloadInterventiPdf] = useState(false)

  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <h1 className="title">Interventi scadenze</h1>
            {isFetching && <Spinner animation="border" role="status" className="ms-4" variant="secondary" size="sm" />}
          </div>
        </div>
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <SegmentedControlLink
              value={INTERVENTI_OPTIONS_TAB.scadenze.value}
              options={Object.values(INTERVENTI_OPTIONS_TAB)}
            />
            {!isCliente && (
              <div className="d-flex align-items-center">
                <Button
                  disabled={isDownloadInterventiXlsx}
                  onClick={async () => {
                    setIsDownloadInterventiXlsx(true)
                    const data = await fetchApi(
                      `${API_URL}/bilance/bilancia/download-excel-scadenze/?${new URLSearchParams({
                        search: filters.search,
                        ordering: filters.ordering,
                        data_gte: filters.data_gte,
                        data_lte: filters.data_lte,
                        rapporto_taratura: filters.rapporto_taratura,
                        verifica_periodica: filters.verifica_periodica,
                      })}`,
                      {
                        headers: {
                          Authorization: `Bearer ${tokens?.access}`,
                        },
                      }
                    )
                    const blob = await data.blob()
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    const dates_for_name = `${dayjs(filters.data_gte).format(
                      'DD-MM-YYYY'
                    )}_${dayjs(filters.data_lte).format('DD-MM-YYYY')}`
                    a.download = 'Interventi_scadenze_' + dates_for_name + '.xlsx'
                    a.click()
                    setIsDownloadInterventiXlsx(false)
                  }}
                  variant="outline-secondary"
                  className="d-flex align-items-center bg-white me-2 text-secondary"
                  type="button"
                >
                  <MaterialIcon icon="download" className="me-2" />
                  Scarica Excel
                  {isDownloadInterventiXlsx && (
                    <Spinner animation="border" variant="secondary" className="ms-4" size="sm" />
                  )}
                </Button>
                <Button
                  disabled={isDownloadInterventiPdf}
                  onClick={async () => {
                    setIsDownloadInterventiPdf(true)
                    const data = await fetchApi(
                      `${API_URL}/bilance/bilancia/download-pdf-scadenze/?${new URLSearchParams({
                        search: filters.search,
                        ordering: filters.ordering,
                        data_gte: filters.data_gte,
                        data_lte: filters.data_lte,
                        rapporto_taratura: filters.rapporto_taratura,
                        verifica_periodica: filters.verifica_periodica,
                      })}`,
                      {
                        headers: {
                          Authorization: `Bearer ${tokens?.access}`,
                        },
                      }
                    )
                    const blob = await data.blob()
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    const dates_for_name = `${dayjs(filters.data_gte).format(
                      'DD-MM-YYYY'
                    )}_${dayjs(filters.data_lte).format('DD-MM-YYYY')}`
                    a.download = 'Interventi_scadenze_' + dates_for_name + '.pdf'
                    a.click()
                    setIsDownloadInterventiPdf(false)
                  }}
                  variant="outline-secondary"
                  className="d-flex align-items-center bg-white me-2 text-secondary"
                  type="button"
                >
                  <MaterialIcon icon="download" className="me-2" />
                  Scarica PDF
                  {isDownloadInterventiPdf && (
                    <Spinner animation="border" variant="secondary" className="ms-4" size="sm" />
                  )}
                </Button>
                <Button
                  onClick={() => {
                    modalActionsPianificaPeriodica.open()
                  }}
                  variant="white"
                  className="text-white d-flex align-items-center btn-outline-periodico"
                  type="button"
                >
                  <span
                    className="material-icons me-2"
                    style={{
                      fontSize: '16px',
                    }}
                  >
                    edit_calendar
                  </span>
                  <span> Pianifica periodica</span>
                </Button>
                <Button
                  onClick={() => {
                    modalActionsPianificaTaratura.open()
                  }}
                  variant="white"
                  className="text-white d-flex align-items-center ms-2 btn-outline-taratura"
                  type="button"
                >
                  <span
                    className="material-icons me-2"
                    style={{
                      fontSize: '16px',
                    }}
                  >
                    edit_calendar
                  </span>
                  <span> Pianifica taratura</span>
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="col-12 mt-3">
          <div
            className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded h-100 position-relative"
            ref={ref}
          >
            <FullCalendar
              // button for print calendar

              plugins={[dayGridPlugin]}
              initialView="dayGridWeek"
              titleFormat={{ year: 'numeric', month: 'long' }}
              events={events}
              dragScroll={false}
              dayHeaderContent={(args) => {
                const isToday = dayjs(args.date).isSame(dayjs(), 'day')
                return (
                  <div className="d-flex justify-content-start flex-column">
                    <div className="p-lg text-decoration-none">{dayjs(args.date).format('dddd')}</div>
                    {args.view.type !== 'dayGridMonth' && (
                      <div
                        className={classNames({
                          'heading-h5 day-calendar': !isToday,
                          'today-calendar': isToday,
                        })}
                      >
                        {dayjs(args.date).format('DD')}
                      </div>
                    )}
                  </div>
                )
              }}
              height={'calc(100vh - 230px)'}
              headerToolbar={{
                left: 'title prev,next',
                center: 'today dayGridWeek,dayGridMonth',
                right: '',
              }}
              datesSet={(info) => {
                setFilters({
                  data_lte: dayjs(info.start).format('YYYY-MM-DD'),
                  data_gte: dayjs(info.end).format('YYYY-MM-DD'),
                })
              }}
              buttonText={{
                today: 'Oggi',
                month: 'Mese',
                week: 'Settimana',
              }}
              locale="it"
              viewClassNames={(arg: ViewContentArg): string | string[] => {
                return arg.view.type === 'dayGridMonth' ? 'month-view' : 'week-view'
              }}
              eventContent={(args) => {
                // check wich is the current view
                const view = args.view.type
                if (view === 'dayGridMonth') {
                  // count how many events are in the same day and show only one event with the count of the others

                  // prepare an array of all names of clients events in the day
                  const clientiRapportoTaratura = events
                    .filter(
                      (event: any) =>
                        dayjs(event.start).isSame(args.event.start, 'day') &&
                        event.tipo_intervento === 'rapporto_taratura'
                    )
                    .map((event: any) => event.title)
                  const clientiInterventoPeriodico = events
                    .filter(
                      (event: any) =>
                        dayjs(event.start).isSame(args.event.start, 'day') &&
                        event.tipo_intervento === 'verifica_periodica'
                    )
                    .map((event: any) => event.title)

                  // show the cliente name only 1 time and the count of the bilance

                  // check if there

                  return (
                    <div className="p-2 w-100">
                      {clientiRapportoTaratura.length > 0 &&
                        clientiRapportoTaratura.map((client: any, index: number) => (
                          <Link
                            key={index}
                            to={`/bilance?data_scadenza_taratura__gte=${dayjs(args.event.start).format(
                              'YYYY-MM-DD'
                            )}&data_scadenza_taratura__lte=${dayjs(args.event.end).format('YYYY-MM-DD')}&&cliente=${
                              events.find(
                                (event: any) => event.title === client && event.tipo_intervento === 'rapporto_taratura'
                              )?.pk_cliente
                            }`}
                            className="no-link w-100 month-event"
                          >
                            <div
                              style={{
                                borderLeft: `4px solid var(--rapporto-taratura-strong)`,
                                backgroundColor: 'var(--rapporto-taratura-light)',
                              }}
                              className="p-2 w-100 mb-1"
                            >
                              <div className="p-sm text-rapporto-taratura d-flex justify-content-between align-items-center w-100 text-wrap">
                                <div key={index}>
                                  {client} (
                                  {
                                    events.find(
                                      (event: any) =>
                                        event.title === client && event.tipo_intervento === 'rapporto_taratura'
                                    )?.bilance_count
                                  }
                                  )
                                </div>
                              </div>
                            </div>
                          </Link>
                        ))}
                      {clientiInterventoPeriodico.length > 0 &&
                        clientiInterventoPeriodico.map((client: any, index: number) => (
                          <Link
                            key={index}
                            to={
                              args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura'
                                ? `/bilance?data_scadenza_taratura__gte=${dayjs(args.event.start).format(
                                    'YYYY-MM-DD'
                                  )}&data_scadenza_taratura__lte=${dayjs(args.event.end).format(
                                    'YYYY-MM-DD'
                                  )}&&cliente=${args.event._def.extendedProps.pk_cliente}`
                                : `/bilance?data_scadenza_periodica__gte=${dayjs(args.event.start).format(
                                    'YYYY-MM-DD'
                                  )}&data_scadenza_periodica__lte=${dayjs(args.event.end).format(
                                    'YYYY-MM-DD'
                                  )}&cliente=${args.event._def.extendedProps.pk_cliente}`
                            }
                            className="no-link w-100 month-event"
                          >
                            <div
                              style={{
                                borderLeft: `4px solid var(--intervento-periodico-strong)`,
                                backgroundColor: 'var(--intervento-periodico-light)',
                              }}
                              className="p-2 w-100 mt-1"
                            >
                              <div className="p-sm text-intervento-periodico d-flex justify-content-between align-items-center w-100 text-wrap">
                                <div key={index}>
                                  {client} (
                                  {
                                    events.find(
                                      (event: any) =>
                                        event.title === client && event.tipo_intervento === 'verifica_periodica'
                                    )?.bilance_count
                                  }
                                  )
                                </div>
                              </div>
                              {/* show button for add richiesta */}
                              {/* @TODO controllare modal che non mostra tutte le informazioni */}
                              {!isCliente && args.event._def.extendedProps.tipo_intervento === 'verifica_periodica' && (
                                <Button
                                  variant="outline-secondary"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    modalActionsAddRichiesta.open({
                                      bilance_pk: args.event._def.extendedProps.bilance_pk,
                                      cliente_pk: args.event._def.extendedProps.pk_cliente,
                                    })
                                  }}
                                  className="mt-2 bg-white"
                                  size="sm"
                                  type="button"
                                >
                                  Aggiungi richiesta
                                </Button>
                              )}
                            </div>
                          </Link>
                        ))}
                    </div>
                  )
                }
                return (
                  <Link
                    to={
                      args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura'
                        ? `/bilance?data_scadenza_taratura__gte=${dayjs(args.event.start).format(
                            'YYYY-MM-DD'
                          )}&data_scadenza_taratura__lte=${dayjs(args.event.end).format('YYYY-MM-DD')}&&cliente=${
                            args.event._def.extendedProps.pk_cliente
                          }`
                        : `/bilance?data_scadenza_periodica__gte=${dayjs(args.event.start).format(
                            'YYYY-MM-DD'
                          )}&data_scadenza_periodica__lte=${dayjs(args.event.end).format('YYYY-MM-DD')}&cliente=${
                            args.event._def.extendedProps.pk_cliente
                          }`
                    }
                    className="no-link w-100 month-event"
                  >
                    <div
                      className={classNames('p-2', 'text-wrap', {
                        'bg-rapporto-taratura-light':
                          args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura',
                        'bg-intervento-periodico-light':
                          args.event._def.extendedProps.tipo_intervento === 'verifica_periodica',
                      })}
                      style={{
                        borderLeft: `4px solid ${
                          args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura'
                            ? 'var(--rapporto-taratura-strong)'
                            : 'var(--intervento-periodico-strong)'
                        }`,
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          className={classNames('badge bg-white', {
                            'text-rapporto-taratura':
                              args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura',
                            'text-intervento-periodico':
                              args.event._def.extendedProps.tipo_intervento === 'verifica_periodica',
                          })}
                        >
                          {args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura'
                            ? 'Taratura'
                            : 'Periodica'}
                        </div>
                        <div
                          className={classNames('d-flex align-items-center', {
                            'text-rapporto-taratura':
                              args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura',
                            'text-intervento-periodico':
                              args.event._def.extendedProps.tipo_intervento === 'verifica_periodica',
                          })}
                        ></div>
                      </div>
                      <div className="heading-h6 mt-2">{args.event.title}</div>
                      <div className="text-body-secondary">{args.event._def.extendedProps.sede}</div>
                      <div className="text-body-secondary d-flex align-items-center">
                        <span
                          className="material-icons me-1 text-intervento-periodico"
                          style={{
                            fontSize: '16px',
                          }}
                        >
                          scale
                        </span>
                        {args.event._def.extendedProps.bilance_count
                          ? args.event._def.extendedProps.bilance_count + ' Bilance'
                          : '1 Bilancia'}
                      </div>
                      {!isCliente && args.event._def.extendedProps.tipo_intervento === 'verifica_periodica' && (
                        <Button
                          variant="outline-secondary"
                          onClick={(e) => {
                            e.preventDefault()
                            modalActionsAddRichiesta.open({
                              bilance_pk: args.event._def.extendedProps.bilance_pk,
                              cliente_pk: args.event._def.extendedProps.pk_cliente,
                            })
                          }}
                          className="mt-2 bg-white"
                          size="sm"
                          type="button"
                        >
                          Aggiungi richiesta
                        </Button>
                      )}
                    </div>
                  </Link>
                )
              }}
            />
          </div>
        </div>
      </div>
      {modalStatePianificaPeriodica.isOpen && (
        <ModalPianificazionePeriodica
          isOpen={modalStatePianificaPeriodica.isOpen}
          toggle={modalActionsPianificaPeriodica.toggle}
          save={async (values: any) => {
            await fetchApi(`${API_URL}/bilance/intervento/pianifica/`, {
              method: 'POST',
              body: JSON.stringify(values),
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
            }).then(() => {
              refetch()
              modalActionsPianificaPeriodica.close()
            })
          }}
        />
      )}
      {modalStatePianificaTaratura.isOpen && (
        <ModalPianificazioneTaratura
          isOpen={modalStatePianificaTaratura.isOpen}
          toggle={modalActionsPianificaTaratura.toggle}
          save={async (values: any) => {
            await fetchApi(`${API_URL}/bilance/intervento/pianifica-tarature/`, {
              method: 'POST',
              body: JSON.stringify(values),
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
            }).then(() => {
              refetch()
              modalActionsPianificaTaratura.close()
            })
          }}
        />
      )}
      {modalStateAddRichiesta.isOpen && (
        <ModalRichiesteDaCalendario
          cliente={modalStateAddRichiesta.value.cliente_pk}
          isOpen={modalStateAddRichiesta.isOpen}
          bilance={modalStateAddRichiesta.value.bilance_pk}
          save={async (values: any) => {
            await fetchApi(`${API_URL}/bilance/intervento/aggiungi-richieste-periodiche/`, {
              method: 'POST',
              body: JSON.stringify(values),
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
            }).then(() => {
              refetch()
              modalActionsAddRichiesta.close()
            })
          }}
          toggle={modalActionsAddRichiesta.toggle}
        />
      )}
    </div>
  )
}
